import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IMatter } from '../interface/matter';
import { InvoicingException } from '../interface/common';
import { showErrorMessage } from '../constants/preliminaryInvoiceCreationErrorHelpe';
import CustomModal from '../components/informationPopup/customModal';
import CreatePreliminaryInvoiceModal from '../components/invoicing/createPreliminaryInvoiceModal';

const getSubMatterException = (matter: IMatter) => {
  if (matter.hasSubMatters) return InvoicingException.MatterHasSubMattersException;
  if (matter.parentMatterId) return InvoicingException.MatterIsSubMatterException;
  return undefined;
};

export const useBillableMatterActions = () => {
  const { t } = useTranslation();
  const [creationMatterId, setCreationMatterId] = useState<string>();
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const onCreatePreliminaryInvoice = (matter: IMatter) => {
    const subMatterException = getSubMatterException(matter);
    if (subMatterException) {
      showErrorMessage(subMatterException, true, setIsError, setErrorMessage, t);
      return;
    }
    setCreationMatterId(matter.id);
  };

  const ErrorModal = (
    <CustomModal
      visible={isError}
      confirmText={t('common:cancel')}
      onConfirm={() => setIsError(false)}
      title={errorMessage}
    />
  );

  const CreationModal = creationMatterId && (
    <CreatePreliminaryInvoiceModal
      matterId={creationMatterId}
      onClose={() => setCreationMatterId(undefined)}
    />
  );

  return { ErrorModal, CreationModal, onCreatePreliminaryInvoice };
};
